import React from 'react';
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt
} from 'react-icons/fa';
import styles from './footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.topBar}></div>

      <div className={styles.inner}>
        {/* Column 1: Brand */}
        <div className={styles.brand}>
          <h4 className={styles.brandName}>Dima Niwas Campsite</h4>
          <p className={styles.brandTagline}>Cum Restaurant</p>
          <p className={styles.brandDesc}>
            Your perfect escape into nature. Enjoy camping, adventure, and serenity surrounded by beautiful landscapes.
          </p>

          {/* Contact info */}
          <div className={styles.contactList}>
            <a href="https://wa.me/919365484564" target="_blank" rel="noreferrer" className={styles.contactItem}>
              <FaWhatsapp className={styles.waIcon} />
              <span>+91 9365484564</span>
            </a>
            <a href="tel:+918011602251" className={styles.contactItem}>
              <FaPhoneAlt className={styles.contactIcon} />
              <span>+91 8011602251</span>
            </a>
            <a href="mailto:info@dimaniwascampsite.in" className={styles.contactItem}>
              <FaEnvelope className={styles.contactIcon} />
              <span>info@dimaniwascampsite.in</span>
            </a>
            <a
              href="https://share.google/5uxbeiPnhyjxUPt4f"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.contactItem}
            >
              <FaMapMarkerAlt className={styles.contactIcon} />
              <span>Didung Razi, Umrangso, Dima Hasao</span>
            </a>
          </div>

          {/* Social Icons */}
          <div className={styles.socials}>
            <a href="#!" className={styles.socialBtn} aria-label="Facebook"><FaFacebookF /></a>
            <a
              href="https://www.instagram.com/dima__niwas__campsite/"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialBtn}
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a href="#!" className={styles.socialBtn} aria-label="Twitter"><FaTwitter /></a>
            <a href="#!" className={styles.socialBtn} aria-label="YouTube"><FaYoutube /></a>
            <a
              href="https://wa.me/919365484564"
              target="_blank"
              rel="noreferrer"
              className={`${styles.socialBtn} ${styles.waSocialBtn}`}
              aria-label="WhatsApp"
            >
              <FaWhatsapp />
            </a>
          </div>
        </div>

        {/* Column 2: Quick Links */}
        <div className={styles.linkCol}>
          <h5 className={styles.colTitle}>Quick Links</h5>
          <ul className={styles.linkList}>
            {['Home', 'Camping Spots', 'Adventure Activities', 'About Us', 'Campsite View'].map(item => (
              <li key={item}>
                <a href="#!" className={styles.link}>{item}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* Column 3: Help */}
        <div className={styles.linkCol}>
          <h5 className={styles.colTitle}>Help</h5>
          <ul className={styles.linkList}>
            <li><a href="/contact" className={styles.link}>Contact Us</a></li>
            <li><a href="/faqs" className={styles.link}>FAQs</a></li>
            <li><a href="/booking" className={styles.link}>Book Your Camp</a></li>
            <li><a href="/privacy-policy" className={styles.link}>Privacy Policy</a></li>
            <li><a href="/adventure-safety-guide" className={styles.link}>Adventure Safety Guide</a></li>
          </ul>
        </div>

        {/* Column 4: Newsletter */}
        <div className={styles.newsletter}>
          <h5 className={styles.colTitle}>Stay Updated</h5>
          <p className={styles.newsletterDesc}>
            Subscribe to get the latest campsite offers and adventure tips.
          </p>
          <input
            type="email"
            placeholder="you@example.com"
            className={styles.emailInput}
          />
          <button className={styles.subscribeBtn}>Subscribe</button>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className={styles.bottomBar}>
        <p className={styles.copyright}>
          © {new Date().getFullYear()} Dima Niwas Campsite &nbsp;|&nbsp; All rights reserved.
        </p>
        <p className={styles.madeWith}>
          Developed and maintained by <a href="https://binudsoftwaresolutions.vercel.app/" target="_blank" rel="noopener noreferrer" className={styles.developerLink}>Binud Software Solutions</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;